import { FunctionComponent, ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import "./SectionTitle.scss";

interface SectionTitleProps {
  icon?: LucideIcon;
  /** numero exibido em badge ciano ao lado */
  count?: number;
  /** acoes alinhadas a direita (botoes, links) */
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /** tamanho do icone (default 18) */
  iconSize?: number;
}

const SectionTitle: FunctionComponent<SectionTitleProps> = ({
  icon: Icon,
  count,
  actions,
  children,
  className = "",
  iconSize = 18,
}) => {
  return (
    <h2 className={`section-title ${className}`.trim()}>
      {Icon && <Icon size={iconSize} />}
      <span className="st-text">{children}</span>
      {typeof count === "number" && <span className="count-badge">{count}</span>}
      {actions && <span className="st-actions">{actions}</span>}
    </h2>
  );
};

export default SectionTitle;
